import { Paper } from "@material-ui/core";

export default Paper;
